import React from 'react';
import PropTypes from 'prop-types';
import { StateCheckboxSC } from './state-checkbox.styled';
import { ReactComponent as CheckIcon } from '../../../../../assets/img/svg/small-check-white.svg';

function StateCheckbox({ state, ...rest }) {
  function getInside() {
    switch (state) {
      case 'none':
        return null;
      case 'partial':
        return '-';
      case 'all':
        return <CheckIcon />;
      default:
        return null;
    }
  }

  return (
    <StateCheckboxSC state={state} {...rest}>
      {getInside()}
    </StateCheckboxSC>
  );
}

StateCheckbox.propTypes = {
  state: PropTypes.oneOf(['none', 'partial', 'all']),
};

export default StateCheckbox;
